var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-container',[(_vm.loading)?_c('div',[_c('b-icon',{attrs:{"icon":"circle-fill","animation":"throb"}}),_vm._v(" "+_vm._s(_vm.$t('common.loading'))+" ")],1):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }